import { colors } from 'global/variables';

export const MARKER_ANCHOR = {
  EDITING: { x: 12, y: 35 },
  NORMAL: { x: 12, y: 24 },
  STOP: { x: 12, y: 35 },
  UNSELECTED: { x: 5, y: 5 },
};

export const POPUP_STYLE = {
  position: 'absolute',
  background: colors.white,
  padding: '10px 12px',
  borderRadius: '4px',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
  fontFamily: "'FiraGO', sans-serif",
  fontSize: '11px',
  color: colors.primaryTextColor,
  minWidth: '250px',
  maxWidth: '350px',
  zIndex: '10000',
  pointerEvents: 'auto',
  overflowY: 'auto',
  maxHeight: '300px',
  transform: 'translate(-50%, -100%)',
  marginBottom: '10px',
};

export const ARROW_STYLE = {
  position: 'absolute',
  bottom: '-8px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '0',
  height: '0',
  borderLeft: '8px solid transparent',
  borderRight: '8px solid transparent',
  borderTop: `8px solid ${colors.white}`,
  filter: 'drop-shadow(0 2px 1px rgba(0,0,0,0.1))',
  pointerEvents: 'auto',
};

export const PANEL_WIDTH_PX = 26 * 16;
export const PADDING_PERCENT = 0.1;

export const AREA_TOOLTIP_STYLE = {
  position: 'absolute',
  background: colors.white,
  padding: '6px 10px',
  borderRadius: '4px',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
  fontFamily: "'FiraGO', sans-serif",
  fontSize: '11px',
  color: colors.primaryTextColor,
  maxWidth: '250px',
  zIndex: '10000',
  pointerEvents: 'none',
};
